'use strict';
import { FeedbackViewBase } from './FeedbackViewBase';
import Render from './FeedbackViewRender';
import { connect } from 'react-redux';

class FeedbackView extends FeedbackViewBase {
    render() {
        return Render.call(this, this.props, this.state);
    }
}

export default FeedbackView = connect((state)=>{
    return {user:state.user || {}}
})(FeedbackView);
